import { format } from 'date-fns';
import { translate } from 'hooks/useTranslate';
import { dateFormat } from 'constants/formats';
import { boardsTypesTexts } from 'modules/_shared/components/BoardsListHeader/constants/boardsTypesTexts';

export const generateBoardsName = (boardType: string): string => {
  const boardText =
    boardsTypesTexts[boardType as keyof typeof boardsTypesTexts];
  const todayText = format(new Date(), dateFormat);
  const translatedText = translate(boardText);

  return `${translatedText} ${todayText}`;
};
